export default __webpack_public_path__ + "static/media/Logoo_new.6191b182.png";